import { NotFoundTemplate } from 'components/index';

export function NotFound() {
  return (
    <NotFoundTemplate />
  );
}
